import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('@@TAP/language');
export const getLanguages = actionCreator.async('GET_LANGUAGES');
export const changeLanguage = actionCreator.async('CHANGE_LANGUAGE');
//# sourceMappingURL=language.actions.js.map